import "./CurrentStatusPanel.scss";

import { useEffect, useState } from "react";
import AdvancedTextArea from "components/inputs/TextArea/AdvancedTextArea";

type CurrentStatusPanelProps = {
  accepted: string;
  denied: string;
  acceptedDate?: string;
  deniedDate?: string;
  onAcceptedChange?: (value: string) => void;
  onAcceptedBlur?: () => void;
  onAcceptedDateChange?: (value: string) => void;
  onAcceptedDateBlur?: () => void;
  onDeniedChange?: (value: string) => void;
  onDeniedBlur?: () => void;
  onDeniedDateChange?: (value: string) => void;
  onDeniedDateBlur?: () => void;
  isEditable?: boolean;
  isCollapsed?: boolean;
  onToggleCollapse?: () => void;
};

const CurrentStatusPanel = ({
  accepted,
  denied,
  acceptedDate = "",
  deniedDate = "",
  onAcceptedChange,
  onAcceptedBlur,
  onAcceptedDateChange,
  onAcceptedDateBlur,
  onDeniedChange,
  onDeniedBlur,
  onDeniedDateChange,
  onDeniedDateBlur,
  isEditable = true,
  isCollapsed = false,
  onToggleCollapse,
}: CurrentStatusPanelProps) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setIsVisible(true), 50);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div
      className={`metadoc-ai-summary ${isVisible ? "metadoc-ai-summary--visible" : ""} ${isCollapsed ? "metadoc-ai-summary--collapsed" : ""}`}
    >
      <div className="metadoc-ai-summary__header">
        <div className="metadoc-ai-summary__badge">
          <span className="material-icons">auto_awesome</span>
          <span className="metadoc-ai-summary__badge-text">
            AI Generated Summary
          </span>
        </div>
        <div className="metadoc-ai-summary__header-actions">
          <button
            className="metadoc-ai-summary__collapse-btn"
            onClick={() => onToggleCollapse?.()}
            title={isCollapsed ? "Expand summary" : "Collapse summary"}
          >
            <span className="material-icons">
              {isCollapsed ? "expand_more" : "expand_less"}
            </span>
          </button>
        </div>
      </div>

      {!isCollapsed && (
        <div className="current-status-panel__content">
          <div className="current-status-panel__section">
            <div className="current-status-panel__section-header">
              <span className="current-status-panel__section-title">
                Accepted
              </span>
              <div className="metadoc-ai-summary__context current-status-panel__date-context">
                <span className="metadoc-ai-summary__context-title">Date</span>
                <input
                  type="date"
                  className="current-status-panel__date-input"
                  value={acceptedDate}
                  onChange={(e) => onAcceptedDateChange?.(e.target.value)}
                  onBlur={onAcceptedDateBlur}
                  disabled={!isEditable}
                />
              </div>
            </div>
            <div className="current-status-panel__section-content">
              <AdvancedTextArea
                value={accepted}
                name="current-status-accepted"
                onChange={onAcceptedChange ?? (() => {})}
                onBlur={onAcceptedBlur}
                isEditable={isEditable}
              />
            </div>
          </div>

          <div className="current-status-panel__section current-status-panel__section--divided">
            <div className="current-status-panel__section-header">
              <span className="current-status-panel__section-title">
                Denied
              </span>
              <div className="metadoc-ai-summary__context current-status-panel__date-context">
                <span className="metadoc-ai-summary__context-title">Date</span>
                <input
                  type="date"
                  className="current-status-panel__date-input"
                  value={deniedDate}
                  onChange={(e) => onDeniedDateChange?.(e.target.value)}
                  onBlur={onDeniedDateBlur}
                  disabled={!isEditable}
                />
              </div>
            </div>
            <div className="current-status-panel__section-content">
              <AdvancedTextArea
                value={denied}
                name="current-status-denied"
                onChange={onDeniedChange ?? (() => {})}
                onBlur={onDeniedBlur}
                isEditable={isEditable}
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CurrentStatusPanel;
